/**
 * DEV-555 — espelho NÃO sensível da sessão do Keycloak em `window.__eurecaSession`.
 *
 * Só instantes (epoch em segundos): quando a sessão foi autenticada (`auth_time`),
 * até quando o token de renovação vale (`exp` do refresh token — para o client
 * público é a inatividade da sessão SSO: 30 dias a cada uso) e o `sid`. Nenhum
 * token, nenhum dado pessoal. É o que permite conferir na tela (e nos fluxos e2e)
 * que a sessão expira 30 dias após o último uso e que a confirmação de identidade
 * não mexe nela.
 */
export interface EurecaSessionInfo {
  /** `auth_time` do access token (epoch s). */
  authTime: number | null;
  /** `exp` do refresh token (epoch s) = último uso + inatividade da sessão. */
  refreshExpiresAt: number | null;
  /** `exp` do access token (epoch s). */
  accessExpiresAt: number | null;
  /** id da sessão SSO. */
  sessionId: string | null;
  /** quando este espelho foi atualizado (epoch ms). */
  updatedAt: number;
}

export interface KeycloakLike {
  tokenParsed?: { auth_time?: number; exp?: number; sid?: string } | undefined;
  refreshTokenParsed?: { exp?: number } | undefined;
}

declare global {
  interface Window {
    __eurecaSession?: EurecaSessionInfo;
  }
}

export function buildSessionInfo(kc: KeycloakLike, now = Date.now()): EurecaSessionInfo {
  return {
    authTime: typeof kc.tokenParsed?.auth_time === 'number' ? kc.tokenParsed.auth_time : null,
    refreshExpiresAt:
      typeof kc.refreshTokenParsed?.exp === 'number' ? kc.refreshTokenParsed.exp : null,
    accessExpiresAt: typeof kc.tokenParsed?.exp === 'number' ? kc.tokenParsed.exp : null,
    sessionId: typeof kc.tokenParsed?.sid === 'string' ? kc.tokenParsed.sid : null,
    updatedAt: now,
  };
}

export function publishSessionInfo(kc: KeycloakLike): void {
  if (typeof window === 'undefined') return;
  window.__eurecaSession = buildSessionInfo(kc);
}
